import {Request} from '../shared/base.requests'
import config from '../../config/customer.api'
import {appInsights} from '../shared/applicationInsights'

const editUserProfileModule = {
  namespaced: true,
  state: {
    customerUser: {
      firstName: '',
      lastName: '',
      mobilePhone: '',
      email: '',
      profilePhoto: '',
      isDemoUser: undefined,
      purchasedSms: false,
      optSmsStatus: 0,
      optSmsStatusMessage: 0,
      optSmsDataChange: '',
      isOptIn: false
    },
    userImage: ''
  },
  mutations: {
    setUserProfile (state, payload) {
      state.customerUser = payload
      state.userImage = payload.profilePhoto
    },
    updateProfileImage (state, payload) {
      state.userImage = payload
    }
  },
  actions: {
    loadUserProfile: function (context) {
      return new Promise((resolve, reject) => {
        let apiUrl = config.userProfile
        Request.GetFromCache(apiUrl, function (json) {
          context.commit('setUserProfile', json)
        })
        Request.get(apiUrl)
          .then((response) => {
            context.commit('setUserProfile', response)
            resolve()
          })
          .catch((error) => {
            appInsights.trackException({
              exception: error,
              message: error.message,
              properties: { apiUrl: apiUrl, accessId: localStorage.accessId }
            })
            appInsights.flush()

            console.error('loadUserProfile failed', error)
            reject()
          })
      })
    },
    saveUserProfile: function (context, data) {
      return new Promise((resolve, reject) => {
        let apiUrl = config.userProfile
        Request.put(apiUrl, data)
          .then((response) => {
            context.commit('setUserProfile', data)
            resolve(response)
          })
          .catch((error) => {
            appInsights.trackException({
              exception: error,
              message: error.message,
              properties: {
                apiUrl: apiUrl,
                data: data,
                accessId: localStorage.accessId
              }
            })
            appInsights.flush()

            console.error('saveCustomer failed', error)
            reject(error)
          })
      })
    },
    uploadImage: function (context, file) {
      let formData = new FormData()
      formData.append('file', file)
      return new Promise((resolve, reject) => {
        let apiUrl = config.uploadFile + '?mediaType=1'
        Request.postMultipartData(apiUrl, formData)
          .then((response) => {
            context.commit('updateProfileImage', response.model)
            resolve()
          })
          .catch((error) => {
            appInsights.trackException({
              exception: error,
              message: error.message,
              properties: {
                apiUrl: apiUrl,
                data: formData,
                accessId: localStorage.accessId
              }
            })
            appInsights.flush()

            console.error('update Profile Image failed', error)
            reject()
          })
      })
    },
    updateImage: function (context, file) {
      context.commit('updateProfileImage', file)
    },
    updateProfile: function (context, data) {
      context.commit('setUserProfile', data)
    }
  },
  getters: {
    getUserProfile: (state) => {
      return Object.assign({}, state.customerUser)
    },
    getUserProfileImage: (state) => {
      return state.customerUser.profilePhoto
    }
  }
}

export default editUserProfileModule



// WEBPACK FOOTER //
// ./scripts/src/store/edit-user-profile.module.js